import { Box, Button, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import {
    FlexBoxFullWHColumn,
    FlexBoxFullWRowBetween,
} from '../../layout/layout.styles';

import { closeDialog, openDialog } from '../../../store/dialog/dialog.action';
import { DIALOG_TYPES } from '../../../store/dialog/dialog.types';
import DialogContent from '../../ui/dialog-content/dialog-content.component';
import DialogTitle from '../../ui/dialog-title/dialog-title.component';
import { CompleteNodeTextBox } from './dialog-complete-node.styles';

const DialogCompleteNode = ({ inputData }: { inputData: any }) => {
    const dispatch = useDispatch();

    const handleConfirm = () => {
        dispatch(
            openDialog(DIALOG_TYPES.NEXT_STEP_NODE, { node: inputData.node })
        );
        console.log(inputData.node);
    };

    const handleCancel = () => {
        dispatch(closeDialog());
    };

    return (
        <Fragment>
            <DialogTitle title="Stai per chiudere il nodo" />
            <DialogContent>
                <FlexBoxFullWHColumn>
                    <CompleteNodeTextBox>
                        <Typography>
                            Ci sono allegati non ancora approvati e/o allegati
                            rifiutati.
                            <br />
                            <br />
                            Sei sicuro di voler confermare il nodo e rendere
                            tutti gli allegati al suo interno pubblici
                            definitivamente?
                            <br />
                            <br />
                            Questa azione non è reversibile.
                        </Typography>
                    </CompleteNodeTextBox>
                    <Box my={1} />
                    <FlexBoxFullWRowBetween alignItems={'end'} mb={1}>
                        <Button
                            onClick={handleCancel}
                            style={{
                                borderRadius: '15px',
                                background: '#FF9595',
                                width: '220px',
                                height: '40px',
                                flexShrink: 0,
                                color: '#fff',
                                border: 'none',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                fontSize: '14px',
                            }}
                        >
                            Annulla
                        </Button>
                        <Button
                            onClick={handleConfirm}
                            sx={{
                                borderRadius: '15px',
                                background: (theme) =>
                                    theme.palette.primary.main,
                                width: '220px',
                                height: '40px',
                                flexShrink: 0,
                                color: 'info.main',
                                border: 'none',
                                cursor: 'pointer',
                                fontWeight: 'bold',
                                fontSize: '14px',
                            }}
                        >
                            CONFERMA
                        </Button>
                    </FlexBoxFullWRowBetween>
                </FlexBoxFullWHColumn>
            </DialogContent>
        </Fragment>
    );
};

export default DialogCompleteNode;
